document.addEventListener("DOMContentLoaded", selectCountryBasedOnLocale);

function selectCountryBasedOnLocale() {
    const dropdownSelectCountry = document.querySelector(".dropdown__select--country");
    const countryList = document.querySelectorAll(".footer__country");
    const documentLanguage = document.documentElement.lang;

    countryList.forEach((country) => {
        if (country.dataset.locale === documentLanguage) {
            dropdownSelectCountry.innerHTML = country.querySelector("a").innerHTML;
        }
    });
}
